<template>
  <sdz-modal 
    ref="modal"
    :width="$isMobile() ? '425' : '800'"
    @close="close"
    @confirm="confirm"
    title="Produtos ativos"
    close-icon
    buttons-position="right"
  >
    <div class="search">
      <AppInput
        v-model="searchQuery"
        class="search__input"
        placeholder="Digite o nome do produto ou SKU"
        prepend-inner-icon="search"
      />

      <div class="search__buttons">
        <v-btn 
          @click="onSearch" 
          color="secondary"
          dark 
        >
          Buscar
        </v-btn>
        <v-btn
          @click="onClean" 
          color="secondary"
          outline
        >
          Limpar
        </v-btn>
      </div>
    </div>

    <AppTable
      v-if="products"
      :headers="headers"
      :items="products"
      :loading="loading"
      :selected="selecteds"
      @table:remove-selecteds="onRemoveAllCurrentPage"
      @table:selected-item="onSelectItem"
      @table:selected-all="onSelectAll"
      checkbox-table
      select-all-check-box
      hide-title
    />

    <span class="d-flex align-center mx-4">
      <v-icon class="mr-1">info_outline</v-icon>
      Não encontrou o produto que precisa? Talvez ele não esteja cadastrado, esteja inativo ou sendo utilizado em outra promoção.
    </span>

    <AppPagination
      :length="pagination.pageCount"
      :currentPagination="pagination.currentPagination"
      @onPagination="onPagination"
    />
  </sdz-modal>
</template>

<script>
import { getProductsAvailables } from '@/services/containers/partners/sale'
import AppTable from '@/components/ui/AppTable.vue'
import AppPagination from '@/components/ui/AppPagination.vue'
import AppInput from '@/components/ui/inputs/AppInput.vue'
import SdzModal from '@/components/sdz/SdzModal.vue'

export default {
  name: 'ProducstModal',
  components: {
    AppTable,
    AppPagination,
    AppInput,
    SdzModal
  },
  data() {
    return {
      show: false,
      products: null,
      loading: false,
      selecteds: [],
      pagination: {
        pageCount: 1,
        totalCount: 0,
        currentPagination: 1
      },
      searchQuery: ''
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Nome do produto',
          value: 'label',
          formatter: ({ label }) => label
        },
        {
          text: 'SKU',
          value: 'sku',
          formatter: ({ sku }) => sku
        },
        {
          text: 'Valor em SDZ',
          value: 'prices',
          formatter: ({ prices }) => prices?.coinValue ? this.$currencyFormat(prices.coinValue) : 'Valor variável'
        }
      ]
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
      this.fetchProducts()
    },
    close() {
      this.$refs.modal.close()
    },
    confirm() {
      // usando spread para não passar a referência do obj
      // se passar ele direto, ao alterá-lo o componente pai tbm é alterado
      // mesmo sem emitir o evento =O
      this.$emit('selectProducts', [...this.selecteds])
      this.close()
    },
    resetPagination() {
      this.pagination = {
        pageCount: 1,
        totalCount: 0,
        currentPagination: 1
      }
    },
    onSelectAll(products) {
      products.forEach(product => {
        if (!this.selecteds.includes(product)) {
          this.selecteds.push(product)
        }
      })
    },
    onSelectItem(selecteds) {
      this.selecteds = selecteds
    },
    onRemoveAllCurrentPage(products) {
      const productsIds = products.map(product => product._id)
      this.selecteds = this.selecteds.filter(product => !productsIds.includes(product._id))
    },
    onSearch() {
      this.resetPagination()
      this.fetchProducts()
    },
    onClean() {
      this.searchQuery = ''
      this.resetPagination()
      this.fetchProducts()
    },
    onPagination(page) {
      this.pagination.currentPagination = page
      this.fetchProducts()
    },
    async fetchProducts() {
      try {
        this.loading = true
        const { data } = await getProductsAvailables(this.pagination.currentPagination, this.searchQuery)
        this.products = data.response.data
        this.pagination.pageCount = data.response.pageCount
        this.pagination.totalCount = data.response.totalCount 
      } catch (error) {
        this.$toast(error.response.data.message, 'red')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.search
  align-items center
  display flex
  padding 0 16px

  .search__input
    flex-grow 3

  .search__buttons
    display flex
    flex-grow 1
    justify-content flex-end

</style>